<template>
  <div id="app">
    <MediaSelector />
    <LibrarySelector />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import LibrarySelector from 'bh-mod/components/file/LibrarySelector'

export default {
  name: 'app',
  components: { MediaSelector,LibrarySelector },
  computed: {
    ...mapGetters(['user']),
  },
  watch: {
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  methods:{

  }
}
</script>
<style>
  #app{
    min-height: 100vh;
  }
</style>
